@let r = route();
<!-- Hero: destination photo (or brand gradient) with the route drawn as a flight path -->
<section class="fr-hero" [class.fr-hero--photo]="!!r.image">
  @if (r.image) {
    <img class="fr-hero__img" [src]="r.image" alt="" width="1600" height="900" fetchpriority="high" decoding="async" />
  }
  <div class="buupass-container fr-hero__inner">
    <nav class="fr-crumbs" aria-label="Breadcrumb">
      <a routerLink="/">Flights</a>
      <app-icon name="chevron" class="fr-crumbs__sep" />
      <span aria-current="page">{{ r.from.city }} to {{ r.to.city }}</span>
    </nav>

    <span class="fr-eyebrow">
      <app-icon name="takeoff" />
      {{ international() ? 'International flights' : 'Domestic flights' }} · One way &amp; return
    </span>
    <h1>{{ r.h1 }}</h1>
    <p class="fr-lede">{{ r.intro[0] }}</p>

    <div class="fr-path" role="img" [attr.aria-label]="r.from.city + ' (' + r.from.iata + ') to ' + r.to.city + ' (' + r.to.iata + '), ' + r.flightTime">
      <div class="fr-path__end">
        <strong>{{ r.from.iata }}</strong>
        <span>{{ r.from.city }}</span>
      </div>
      <div class="fr-path__line" aria-hidden="true">
        <span class="fr-path__dot"></span>
        <app-icon name="plane" class="fr-path__plane" />
        <span class="fr-path__dot"></span>
        <span class="fr-path__time">{{ r.flightTime }}</span>
      </div>
      <div class="fr-path__end fr-path__end--to">
        <strong>{{ r.to.iata }}</strong>
        <span>{{ r.to.city }}</span>
      </div>
    </div>
  </div>
</section>
